import { render, staticRenderFns } from "./UserYearScoreList.vue?vue&type=template&id=aaf6f2e2&scoped=true"
import script from "./UserYearScoreList.vue?vue&type=script&lang=js"
export * from "./UserYearScoreList.vue?vue&type=script&lang=js"
import style0 from "./UserYearScoreList.vue?vue&type=style&index=0&id=aaf6f2e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf6f2e2",
  null
  
)

export default component.exports